import { render, staticRenderFns } from "./selectInput.vue?vue&type=template&id=38ddb4aa"
import script from "./selectInput.vue?vue&type=script&lang=js"
export * from "./selectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports